import React, { useState, useEffect } from 'react';
import classnames from "classnames";
import PropTypes from "prop-types";
import TextField from '@material-ui/core/TextField';
import { withStyles, Button } from "@material-ui/core";
import LinearProgress from "@material-ui/core/LinearProgress";
import DatePicker from '../../components/DatePicker';
import { addDays, addMonths, startOfMonth, subDays, format, differenceInCalendarDays } from 'date-fns';

// SERVICES
import { createOrdersInSalesforce, UpdateClosedOrdersToSalesforce, SendFinalReportsToSalesforce } from '../../services';

const styles = theme => ({
    container: {
        flex: 1,
        backgroundColor: "white",
        margin: 20,
        padding: 20,

        '& > *': {

            alignSelf: 'stretch'
        }
    },
    divider: {
        borderleft: "6px black"
    },
});

export const IntegrateWithSalesforce = withStyles(styles)(props => {
    const { classes } = props;
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [startDateReport, setStartDateReport] = useState(null);
    const [endDateReport, setEndDateReport] = useState(null);
    const [isRunning, setIsRunning] = useState(false);
    const [orderTicket, setOrderTicket] = useState('');
    const [orderTicketReport, setOrderTicketReport] = useState('');

    const updateEndDate = date => {
        document.getElementById('message').innerHTML = '';
        // do not allow selection of a date equal to or after today
        const diffInDaysEnd = differenceInCalendarDays(new Date(), date);

        if (diffInDaysEnd < 0) {
            document.getElementById('message').innerHTML = 'Start and end dates must be in the past.';
            return;
        }

        // do not allow selection of a date less than the start date
        const diffInDaysStart = differenceInCalendarDays(date, startDate);
        if (diffInDaysStart < 0) return;

        setEndDate(date);
    };
    const updateEndDateReport = date => {
        document.getElementById('message').innerHTML = '';
        // do not allow selection of a date equal to or after today
        const diffInDaysEnd = differenceInCalendarDays(new Date(), date);

        if (diffInDaysEnd < 0) {
            document.getElementById('message').innerHTML = 'Start and end dates must be in the past.';
            return;
        }

        // do not allow selection of a date less than the start date
        const diffInDaysStart = differenceInCalendarDays(date, startDateReport);
        if (diffInDaysStart < 0) return;

        setEndDateReport(date);
    };

    const updateStartDate = date => {
        setStartDate(date);
    }
    const updateStartDateReport = date => {
        setStartDateReport(date);
    }
    
    const createNewOrders = async () => {
        //if we want to set a date/time at some point
        //const rctTestFile = document.getElementById("txtRCT").value;
        setIsRunning(true);
        document.getElementById('message').innerHTML = '';
        
        try {
            const returnMessage = await createOrdersInSalesforce();
            document.getElementById('message').innerHTML = returnMessage.result;
        }
        catch (error) {
            var errMsg = 'Error : ' + error;
            if (error + "" == "Error : [object Response]")
                errMsg = "Error: Contact Admin";
            document.getElementById('message').innerHTML = errMsg;
        } finally {
            setIsRunning(false);
        }
    };

    const updateClosedOrders = async () => {

        //if we want to set a date/time at some point
        //const rctTestFile = document.getElementById("txtRCT").value;
        setIsRunning(true);
        document.getElementById('message').innerHTML = '';

        if (!orderTicket && !(startDate && endDate)) {
            document.getElementById('message').innerHTML = 'You must select a date range or specify an Order';
            setIsRunning(false);
        }
        else {
            try {
                const returnMessage = await UpdateClosedOrdersToSalesforce(startDate, endDate, orderTicket);
                document.getElementById('message').innerHTML = returnMessage.result;
            }
            catch (error) {
                var errMsg = 'Error : ' + error;
                if (error + "" == "Error : [object Response]")
                    errMsg = "Error: Contact Admin";
                document.getElementById('message').innerHTML = errMsg;

            } finally {
                setIsRunning(false);
            }
        }
    };

    const SendFinalReports = async () => {
        setIsRunning(true);
        document.getElementById('message').innerHTML = '';

        if (!orderTicketReport && !(startDateReport && endDateReport)) {
            document.getElementById('message').innerHTML = 'You must select a date range or specify an Order';
            setIsRunning(false);
        }
        else {
            try {
                const returnMessage = await SendFinalReportsToSalesforce(startDateReport, endDateReport, orderTicketReport);
                document.getElementById('message').innerHTML = returnMessage.result;
            }
            catch (error) {
                var errMsg = 'Error : ' + error;
                if (error + "" == "Error : [object Response]")
                    errMsg = "Error: Contact Admin";
                document.getElementById('message').innerHTML = errMsg;

            } finally {
                setIsRunning(false);
            }
        }
    };

    const handleOrderTicketOnChange = event => {
        setOrderTicket(event.target.value);
    };
    const handleOrderTicketReportOnChange = event => {
        setOrderTicketReport(event.target.value);
    };    
    const setDefaults = async () => {        

    }

    useEffect(() => {
        //setDefaults();
    }, []);

    return (
        <div className={classnames('flex-1', 'card', 'border-left-green', 'col-center-center', 'align-stretch')}>
            <div className={classnames(classes.inputForm, 'row-between-center')} style={{ width:'100%'}}>
               
                <div className={classnames('col-center-start')} style={{ height: '100%' }}>    
                    <div className={classnames('row-center-center')} style={{ marginLeft: 50 }}>
                    <Button
                        variant="contained"
                        style={{ backgroundColor: 'var(--jmi-blue)', color: 'white', marginRight: 30 }}
                        onClick={createNewOrders}
                        disabled={isRunning}
                    >
                        Push Open Orders
                    </Button>
                    </div>
                    <div className={classnames('row-start-center')}>
                    </div>
                </div>
                <div className={classnames('col-center-center', 'border-left-green')} style={{ height: '70%' }}>
                    <div style={{ marginLeft: 50 }}>
                    
                        <div className={classnames('row-start-start')} style={{ opacity: 0.5, width: '70%', marginLeft: 50 }}>
                            Closed Date Range:
                        </div>

                        <div className={classnames('row-end-center')}>
                            <span className={classnames('mr-15', 'text-left')} style={{ width: 60 }}>
                                Start:
                            </span>
                            <DatePicker disabled={isRunning} selected={startDate} onChange={updateStartDate} />
                        </div>
                        <div className={classnames('row-end-center')}>
                            <span className={classnames('mr-15', 'text-left')} style={{ width: 60 }}>
                                End:
                            </span>
                            <DatePicker disabled={isRunning} selected={endDate} onChange={updateEndDate} />
                        </div>
                        <br />
                        <div className={classnames('row-center-center')} style={{ opacity: 0.5, width: '50%' }}>
                            - OR -
                        </div>

                        <br />
                        <TextField
                            disabled={isRunning}
                            onChange={handleOrderTicketOnChange}
                            label="Order Ticket"
                            margin="dense"
                            id="orderTicketField"
                            type="text"
                            multiline
                            fullWidth />

                            <br />
                            <br />

                        <div >
                            <Button
                                variant="contained"
                                style={{ backgroundColor: 'var(--jmi-blue)', color: 'white' }}
                                onClick={updateClosedOrders}
                                disabled={isRunning}
                            >
                                Update Closed Orders
                            </Button>
                        </div>
                    </div>


                </div>
                
                <div className={classnames('col-center-center', 'border-left-green')} style={{ height: '70%' }}>
                    <div style={{ marginLeft: 50 }}>
                        <div className={classnames('row-start-start')} style={{ opacity: 0.5, width: '70%' }}>
                            Closed Date Range:
                        </div>
                    
                        <div className={classnames('row-end-center')}>
                            <span className={classnames('mr-15', 'text-left')} style={{ width: 60 }}>
                                Start:
                            </span>
                            <DatePicker disabled={isRunning} selected={startDateReport} onChange={updateStartDateReport} />
                        </div>
                        <div className={classnames('row-end-center')}>
                            <span className={classnames('mr-15', 'text-left')} style={{ width: 60 }}>
                                End:
                            </span>
                            <DatePicker disabled={isRunning} selected={endDateReport} onChange={updateEndDateReport} />
                        </div>
                        <br />
                        <div className={classnames('row-start-center')} style={{ opacity: 0.5, width: '50%' }}>
                            - OR -
                        </div>

                        <br />
                        <TextField
                            disabled={isRunning}
                            onChange={handleOrderTicketReportOnChange}
                            label="Order Ticket"
                            margin="dense"
                            id="orderTicketReportField"
                            type="text"
                            multiline
                            fullWidth/>

                        <br />
                        <br />
                    
                        <div >
                            <Button
                                variant="contained"
                                style={{ backgroundColor: 'var(--jmi-blue)', color: 'white' }}
                                onClick={SendFinalReports}
                                disabled={isRunning}
                            >
                                Send Final Reports
                            </Button>
                        </div>

                    </div>

                </div>
            </div>

            <div className={classnames('flex-1', 'col-center-center', 'align-stretch')} style={{ background: '#ccc' }}>
                <div className={'col-center-center'}>
                    <div id="message">
                    </div>

                    {/* shows a message whenever the integration is running */}
                    {isRunning && (
                        <div style={{ marginTop: 20, fontSize: 24 }}>
                            <div style={{ marginBottom: 20 }}>Please wait while the integration is running</div>
                            <LinearProgress />
                        </div>
                        )}
                </div>

            </div>
        </div>
    );
});

IntegrateWithSalesforce.propTypes = {
    classes: PropTypes.object
};

IntegrateWithSalesforce.defaultProps = {};